
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import hi from "./locales/hi.json";
import de from "./locales/de.json";
import fr from "./locales/fr.json";
import ar from "./locales/ar.json";

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: {
                translation: en
            },

            hi: {
                translation: hi
            },

            de: {
                translation: de
            },

            fr: {
                translation: fr
            },

            ar: {
                translation: ar
            }
        },

        /*
         * Default language
         */
        fallbackLng: "en",

        /*
         * Supported languages
         */
        supportedLngs: [
            "en",
            "hi",
            "de",
            "fr",
            "ar"
        ],

        /*
         * Language detection
         *
         * localStorage:
         * User manually selected language
         *
         * navigator:
         * Browser language
         */
        detection: {

            order: [
                "localStorage",
                "navigator"
            ],

            caches: [
                "localStorage"
            ]
        },

        /*
         * React interpolation
         */
        interpolation: {
            escapeValue: false
        },

        /*
         * React settings
         */
        react: {
            useSuspense: false
        }
    });

export default i18n;
